export default "__VITE_ASSET__CnJ9x8zG__"